












































































































import {Vue, Component, Provide} from 'vue-property-decorator';
import Class from '@/models/class';

import Paginition from '@/components/Paginition.vue';
import router from '@/router/index';
import FilterMenu from '@/components/FilterMenu.vue';
import {Filter} from '@/utils/Filter';
import {API} from '@/services/api/api';
import Logo from '@/models/logo';

import {Utils} from '@/utils/Utils';
import moment from 'moment';
import {mapActions} from 'vuex';
import {getUserCompanyId} from '@/services/api/user';
import {mergeBase64toImage} from '@/services/api/image';
import {setAppLogo} from '@/services/api/common';

@Component({
  components: {
    Paginition,
    FilterMenu,
  },
  methods: {...mapActions(['showSuccessToast', 'showErrorToast', 'setLogo'])},
})
export default class logoList extends Vue {
  //logoCaption
  header = [
    {
      value: 'logoCaption',
      name: 'Name',
      headerType: 'text',
      asdcOrder: true,
      filter: true,
      sortable: true,
    },
    {
      value: 'logoName',
      name: 'File name',
      headerType: 'text',
      asdcOrder: true,
      filter: true,
      sortable: true,
    },
    {
      value: 'status',
      name: 'Status',
      headerType: 'text',
      filter: false,
      sortable: false,
      bindClass: 'text-center',
    },
    {
      value: 'logoCreatedDate',
      name: 'Created',
      headerType: 'date',
      asdcOrder: true,
      filter: true,
      sortable: true,
    },

    {
      value: 'edit',
      name: 'Edit',
      headerType: 'text',
      filter: false,
      sortable: false,
      bindClass: 'text-center',
    },
    {
      value: 'delete',
      name: 'Delete',
      headerType: 'text',
      filter: false,
      sortable: false,
      bindClass: 'text-center',
    },
  ];

  logoList: Logo[] = []; //api response
  filteredLogoList: Logo[] = [];
  startingPoint = 0; //pagination starting point
  endingPoint = 5; //pagination ending point
  clearPaginition = false; // default paginition
  numberOfRows = 5;

  //Store Variables
  showSuccessToast: any;
  showErrorToast: any;
  setLogo: any;

  deleteStatus: any = null;
  //sorting variables
  curentSort = ''; //current sort on which header
  asdcOrder = true;

  //modal & loader variables
  modalConfimationMsg: any = null;
  modalTitle: any = null;
  modalVisible = false;
  isScreenLoading = true;
  loadingBtnStatus = false;

  //other variables
  logoId: any = null;
  recordActiveStatus: any = null;
  mounted() {
    this.getLogoList();
  }

  //sorting  list
  async clickOnSort(header: any) {
    if (this.curentSort !== header.value) {
      this.curentSort = header.value;
      this.asdcOrder = true;
    }
    let sorted = Utils.sortData(this.asdcOrder, header, this.filteredLogoList);
    this.asdcOrder = sorted;
  }

  //pagination value listener show data based on pagination
  onPaginitionValueChange(startingPoint: number, endingPoint: number, records: number) {
    this.numberOfRows = records;
    this.startingPoint = startingPoint - 1;
    this.endingPoint = endingPoint;
  }

  // format date to human readable string
  formatDate(originalDate: string) {
    let formattedDate = Utils.formatDate(originalDate);
    return formattedDate;
  }

  // load list from api
  async getLogoList() {
    try {
      let apiResponse = await API.getLogoList();
      this.isScreenLoading = false;
      if (apiResponse.data !== '' && apiResponse.data !== null) {
        let logos: Logo[] = apiResponse.data;
        this.logoList = logos;
        this.filteredLogoList = logos;
        this.setAppLogo(logos);
      } else {
        this.showErrorToast({msg: apiResponse.error});
      }
    } catch (e) {
      this.isScreenLoading = false;
      this.showErrorToast({msg: e});
    }
  }

  //filter data based upon string parameters
  filterOnText(emittedFilterParams: any) {
    let filteredData = Filter.filterOnTextData(emittedFilterParams, this.logoList);

    this.filteredLogoList = filteredData;
    this.resetPagination();
  }

  //filter data based upon date parameters
  filterOnDate(emittedFilterParams: any) {
    let filteredData = Filter.filterOnDateData(emittedFilterParams, this.logoList);

    this.filteredLogoList = filteredData;
    this.resetPagination();
  }

  //reset all filters and show complete list of data
  resetFilter(isDefaultList: boolean) {
    if (isDefaultList) {
      this.filteredLogoList = this.logoList;
      this.resetPagination();
    }
  }

  //show delete confirmation  modal
  displayDeleteModal(recordId: number) {
    this.logoId = recordId;
    this.modalVisible = true;
    this.modalTitle = 'Delete Confirmation';
    this.modalConfimationMsg = 'Are you sure want to delete ?';
    this.deleteStatus = true;
  }

  //show activate/deactivate  confirmation  modal
  displayStatusModal(recordId: number, recordEnableStatus: boolean) {
    this.logoId = recordId;

    let msg;
    if (recordEnableStatus) {
      msg = 'Deactivate';
    } else {
      msg = 'Activate';
    }

    this.modalVisible = true;
    this.modalTitle = `${msg} Confirmation`;
    this.modalConfimationMsg = `Are you sure want to ${msg.toLowerCase()} ?`;
    this.deleteStatus = false;
  }

  //call delete or activate/deactivate method based upon confirmation
  public async deleteOrChangeStatus() {
    try {
      const response = this.deleteStatus ? await this.deleteRecord(this.logoId) : await this.changeStatus(this.logoId);

      const message = this.deleteStatus ? 'Record deleted successfully' : 'Record updated successfully';

      if (response) {
        this.showSuccessToast({msg: message});
        this.getLogoList();
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
    }
  }

  //delete record
  async deleteRecord(logoId) {
    return await API.deleteLogoById(logoId);
  }

  //change status of logo
  async changeStatus(logoId) {
    let source = 'logo';
    const logo = this.logoList.find((u) => u.logoId === logoId);
    return await API.changeRecordStatus(source, logoId, !logo.logoIsActive);
  }

  //reset pagination to first page
  resetPagination() {
    const pagination: any = this.$refs.pagination;
    setTimeout(() => {
      pagination.reset();
    }, 150);
  }

  //navigate to edit-logo screen
  editLogo(logoId: number) {
    this.$router.push({path: `/edit-logo/` + logoId});
  }

  //helper methods
  setAppLogo(list: Logo[]) {
    const companyId = getUserCompanyId();
    const activeLogo = list.find((logo) => {
      return logo.companyId == companyId && logo.logoIsActive;
    });
    setAppLogo(this.setLogo, activeLogo?.logoId);
  }
}
